import { useDebouncedCallback as usePackageDebouncedCallback, Options as DebounceOption } from "use-debounce";

export const useDebouncedCallback = <T extends (...args: any) => ReturnType<T>>(
  func: T,
  wait = 600,
  options?: DebounceOption
) => {
  return usePackageDebouncedCallback(func, wait, options);
};
